import { Badge } from '../components';
import { usePolling } from '../api';

const STAGE_LABELS = {
  S1_symmetry: 'S1 symmetry',
  S2_alignn_gap: 'S2 ALIGNN gap',
  S3_vasp_relax: 'S3 VASP relax',
  S4_vasp_magnetic: 'S4 magnetic',
  S5_mp_hull: 'S5 MP hull',
  S6_prophet_phonons: 'S6 Prophet',
  S7_qe_relax_pm: 'S7 QE relax P/M',
  S8_qe_phonons: 'S8 QE phonons',
  S9_epw_tc: 'S9 EPW Tc',
};

function Funnel({ funnel }) {
  return (
    <div>
      {funnel.map(({stage, counts}) => {
        const total = Object.values(counts).reduce((a, b) => a + b, 0) || 1;
        const order = ['passed', 'rejected', 'flagged', 'unresolved', 'running', 'pending'];
        return (
          <div className="funnel-stage" key={stage}>
            <span className="name">{STAGE_LABELS[stage] || stage}</span>
            <div className="funnel-bar">
              {order.map(k => counts[k] ? (
                <div key={k} className={k}
                     style={{width: `${100 * counts[k] / total}%`}}
                     title={`${k}: ${counts[k]}`} />
              ) : null)}
            </div>
            <span className="muted mono" style={{fontSize: 12, width: 190}}>
              {order.filter(k => counts[k]).map(k => `${k[0].toUpperCase()}${counts[k]}`).join(' ')}
            </span>
          </div>
        );
      })}
    </div>
  );
}

export default function Overview() {
  const {data, error} = usePolling('/overview');

  if (error) return <p className="muted">API 错误：{error}</p>;
  if (!data) return <p className="muted">加载中…</p>;
  const run = data.latest_run;
  const jobs = data.jobs || {};
  const byStatus = data.candidates_by_status || {};

  return (
    <div>
      <h2>Overview</h2>
      <div className="stat-cards">
        {run ? (
          <div className="stat-card">
            <div className="num" style={{fontSize: 15}}>{run.name}</div>
            <div className="lbl">run #{run.id} · <Badge v={run.status} /> · {run.n_candidates ?? '—'} candidates</div>
          </div>
        ) : (
          <div className="stat-card"><div className="num">—</div><div className="lbl">尚无 run（POST /api/runs 创建）</div></div>
        )}
        <div className="stat-card">
          <div className="num">{jobs.running ?? 0}</div>
          <div className="lbl">jobs 在途
            {jobs.by_backend && Object.entries(jobs.by_backend).map(([b, n]) =>
              ` · ${b}:${n}`)}
          </div>
        </div>
        <div className="stat-card">
          <div className="num">{data.diagnoses_pending}</div>
          <div className="lbl">diagnoses 待审查</div>
        </div>
        {Object.entries(byStatus).map(([s, n]) => (
          <div className="stat-card" key={s}>
            <div className="num"><Badge v={s} /></div>
            <div className="lbl">{n} candidates</div>
          </div>
        ))}
      </div>

      <div className="panel">
        <h3>9 阶段漏斗</h3>
        {run ? <Funnel funnel={data.funnel} /> : <p className="muted">无 run</p>}
      </div>

      <div className="row">
        <div className="panel col">
          <h3>终态标签分布</h3>
          {Object.keys(data.candidates_by_label || {}).length === 0
            ? <p className="muted">暂无</p>
            : Object.entries(data.candidates_by_label).map(([l, n]) => (
              <div key={l} style={{padding: '2px 0'}}>
                <span className="badge">{l}</span> <span className="muted">× {n}</span>
              </div>))}
        </div>
        <div className="panel col">
          <h3>当前阶段分布</h3>
          {Object.keys(data.candidates_by_stage || {}).length === 0
            ? <p className="muted">暂无</p>
            : Object.entries(data.candidates_by_stage).map(([s, n]) => (
              <div key={s} className="funnel-stage">
                <span className="name">{STAGE_LABELS[s] || s}</span>
                <span>{n}</span>
              </div>))}
        </div>
      </div>
    </div>
  );
}
